import { useTranslation } from '@sib/i18n';
import { FileItem, FileStatus } from '@sib/types';

export const useFileUploadItem = (fileItem: FileItem) => {
  const { t } = useTranslation();
  const isUploaded = fileItem.status === FileStatus.Uploaded;
  const isError = fileItem.status === FileStatus.Error;
  const isFileUploading = fileItem.status === FileStatus.Uploading;
  const isFileDownloadable = !!fileItem?.downloadUrl;

  const getUploadPhase = () => {
    if (fileItem.progress >= 100) {
      return t('fileManager.uploadPhases.complete');
    }

    if (fileItem.progress > 0) {
      return t('fileManager.uploadPhases.uploading');
    }

    if (fileItem.md5Hash) {
      return t('fileManager.uploadPhases.waiting');
    }

    return t('fileManager.uploadPhases.processing');
  };

  return {
    isUploaded,
    isError,
    isFileUploading,
    isFileDownloadable,
    getUploadPhase,
  };
};
